module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAHklEQVQImWM8cPrOfwYoYPz//z+CIyGiCuEwMDAAAOYgCLaqFfpYAAAAAElFTkSuQmCC"